import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', display: 'flex', flexDirection: 'column', color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18, borderBottom: '1px solid rgba(0,0,0,.3)', width: '100%', paddingTop: 20, paddingBottom: 20
    },
    title: {
        width: '100%', display: 'flex', justifyContent: 'center'
    },
    mb: {
        marginBottom: 12
    },
    wrapBlock: {
        padding: '0 20px', display: 'flex', justifyContent: 'space-between', columnGap: 5
    },
    w50: {
        width: '50%'
    },
    wrapHelper: {
        display: 'flex', justifyContent: 'center', marginBottom: 12
    },
    helper: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        lineHeight: 0,
        display: 'flex',
        justifyContent: 'center'
    },
    flexbox: {
        display: 'flex', alignItems: 'center'
    },
    titleBlock: {
        color: 'hsla(0,0%,100%,.5)',
        width: '60px',
        fontSize: '14px',
        textAlign: 'right',
        fontFamily: 'PT-sans, sans-serif',
        paddingTop: 2,
    },
    amount: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        lineHeight: 0,
        paddingLeft: 16
    }
}))

const CashiersItem = ({ item }) => {
    const classes = useStyles();
    const { groups, sum_deposit, sum_withdrawal, sum_air_withdrawal, sum_air } = item;

    return (
        <div className={classes.root}>
            <div className={classes.mb}>
                <span className={classes.title}>{groups}</span>
            </div>

            <div className={classes.wrapBlock}>
                <div className={classes.w50}>
                    <div className={classes.wrapHelper}>
                        <span className={classes.helper}>Наличные</span>
                    </div>

                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Вход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(sum_deposit)}
                        </span>
                    </div>
                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Выход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(sum_withdrawal ? sum_withdrawal.toFixed(2) : sum_withdrawal)}
                        </span>
                    </div>
                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Разница:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(sum_deposit - sum_withdrawal)}
                        </span>
                    </div>
                </div>
                <div style={{ width: '50%' }}>
                    <div className={classes.wrapHelper}>
                        <span className={classes.helper}>Воздух</span>
                    </div>

                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Вход:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(sum_air ? sum_air.toFixed(2) : sum_air)}
                        </span>
                    </div>
                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Выход:</span>
                        <span className={classes.amount} >
                            {new Intl.NumberFormat('ru-RU').format(sum_air_withdrawal ? sum_air_withdrawal.toFixed(2) : sum_air_withdrawal)}
                        </span>
                    </div>
                    <div className={classes.flexbox}>
                        <span className={classes.titleBlock}>Разница:</span>
                        <span className={classes.amount}>
                            {new Intl.NumberFormat('ru-RU').format(sum_air - sum_air_withdrawal)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CashiersItem;